import Util from '../../../lib/util.jsx'
import app from '../../../app.jsx'

export const getInvoicePdfUrl = (invoice, bIsDetails) => {
  if (invoice) {
    const pdfFileName = Util.getPdfFileName(
      'invoice',
      invoice.invoiceNo,
      invoice.status
    )
    return encodeURI(
      `/invoice/preview/${app.getTeamId()}/${app.loggedInId}/${invoice.id}/${
        bIsDetails ? 'true' : 'false'
      }/${pdfFileName}`
    )
  }
  return ''
}

export const fetchTeam = (teamId) => app
  .service('/api/team')
  .get(teamId)
  .then((team) => team)
  .catch((err) => {
    app.debug('err fetching Team', err)
  })
